import { httpClient } from '../http-client';
import { NoContent } from './manage-portfolios.types';
import { Portfolio } from '../portfolio-considerations/portfolio-considerations.types';
import { Paginated, PaginationQueryParams } from '../api.types';

export const getAllPortfolios = async ({ page, size }: PaginationQueryParams) => {
	const { data } = await httpClient.get<Paginated<Portfolio>>(`/portfolio-recommendations`, {
		params: { page, size },
	});

	return data;
};

export const uploadTemplate = async (formData: FormData): Promise<NoContent> => {
	const { data } = await httpClient.post<NoContent>('/portfolio-upload', formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	});

	return data;
};
